define('rebrush/system/animation',[
    'modernizr'
], function() {
    var animEndEventNames = {
            'WebkitAnimation' : 'webkitAnimationEnd',
            'OAnimation' : 'oAnimationEnd',
            'msAnimation' : 'MSAnimationEnd',
            'animation' : 'animationend'
        },
        transEndEventNames = {
            'WebkitTransition' : 'webkitTransitionEnd',
            'MozTransition' : 'transitionend',
            'OTransition' : 'oTransitionEnd',
            'msTransition' : 'MSTransitionEnd',
            'transition' : 'transitionend'
        };

    return {
        animationEndEventName: animEndEventNames[Modernizr.prefixed('animation')],
        transitionEndEventName: transEndEventNames[ Modernizr.prefixed('transition')],
        supportAnimations: Modernizr.cssanimations,
        supportTransitions: Modernizr.csstransitions
    };
});
